import { TemplateConfig } from '../../template-config.interface';

export const disneyRelated: TemplateConfig = {
  id: 'related',
  clientId: 'DISNEY',
  title: 'Relacionados',
  description: 'Contenido relacionado',
  aspectRatio: 'vertical',
  disabled: true,
  image: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/relacionados.png',
  optimized_image: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/optimized/relacionados.png',
  video: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/previews/relacionados.mp4',
  formFields: [],
  promptTemplate: ''
};
